import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'exam',
    name: 'Exam',
    component: () => import('@/views/exam/index.vue')
  },
  {
    path: '/exam/answer-questions',
    name: 'AnswerQuestions',
    meta: {
      title: '考试',
      breadcrumb: {
        label: '考试',
        path: '/exam'
      }
    },
    component: () => import('@/views/exam/AnswerQuestions/index.vue')
  },
  {
    path: '/exam/answer-record',
    name: 'AnswerRecord',
    meta: {
      title: '考试',
      breadcrumb: {
        label: '考试记录',
        path: '/exam'
      }
    },
    component: () => import('@/views/exam/AnswerRecord/index.vue')
  },
  {
    path: '/exam/procedural',
    name: 'ExamProcedural',
    meta: {
      title: '考试报名',
      breadcrumb: {
        label: '考试报名',
        path: '/exam'
      }
    },
    component: () => import('@/views/exam/procedural/index.vue')
  }
]

export default routes
